import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip adding token for auth endpoints
    if (this.isAuthEndpoint(req.url)) {
      return next.handle(req);
    }

    // Get token from localStorage - use exact key 'access_token'
    let token = localStorage.getItem('access_token');
    
    // If no access_token, try other common keys as fallback
    if (!token) {
      token = localStorage.getItem('token') || 
              localStorage.getItem('authToken') || 
              localStorage.getItem('jwt') ||
              localStorage.getItem('userToken');
    }

    if (token) {
      // Trim spaces and ensure no duplicate "Bearer "
      token = token.trim();
      if (token.startsWith('Bearer ')) {
        token = token.substring(7); // Remove "Bearer " prefix if present
      }
      
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req);
  }

  private isAuthEndpoint(url: string): boolean {
    // Use exact path matching for auth endpoints
    const authEndpoints = [
      '/api/Auth/login',
      '/api/Auth/reset-password',
      '/api/Auth/change-password',
      '/api/Auth/send-email-password',
      '/api/Auth/logout'
    ];
    
    return authEndpoints.some(endpoint => url.endsWith(endpoint));
  }
}
